<template>
  <div class="user-verify-type">
    <a-radio-group name="verifyType" v-model="type">
      <a-radio v-for="item in types" :value="item.key" :key="item.key">
        {{ item.label }}
      </a-radio>
    </a-radio-group>
    <div style="line-height: 24px;">{{ value }}</div>
  </div>
</template>

<script>
import { find } from 'lodash'

export default {
  name: 'user-verify-type',
  data () {
    return {
      type: '',
      types: []
    }
  },
  computed: {
    value () {
      const { type, types } = this

      if (type) {
        const item = find(types, { key: type })

        if (item) {
          this.$emit('change', type, item.value)
          return item.title
        }
      }

      return ''
    }
  },
  created () {
    const userInfo = this.$ls.get('USER_CENTER_INFO')
    const types = []
    let type

    if (userInfo.email && userInfo.emailStatus === 0) {
      types.push({
        value: userInfo.email,
        label: '邮箱',
        title: userInfo.email,
        key: 'email'
      })
      type = 'email'
    }

    if (userInfo.phone && userInfo.phoneStatus === 0) {
      types.unshift({
        value: userInfo.phone,
        title: `+${userInfo.areaCode || '86'} ${userInfo.phone}`,
        label: '手机',
        key: 'mobile'
      })
      type = 'mobile'
    }

    this.types = types
    this.type = type

    if (!type) {
      this.$emit('error')
    }
  }
}
</script>
